/* ============
 * Actions for the website module
 * ============
 *
 * The actions that are available on the
 * website module.
 */

import * as types from './mutation-types';
import WebsiteProxy from '../../../proxies/WebsiteProxy';

export const find = ({ state, commit, rootState }, websiteId) => {
  return new WebsiteProxy()
    .setParameters({ id: websiteId })
    .all()
    .then((response) => {
       commit(types.FIND, response.data)
    })
    .catch((error) => {
      console.log(error);
    });
};

export const clean = ({ state, commit, rootState }) => {
  commit(types.CLEAN)
};

export default {
  find,
  clean
};
